<template lang="pug">
  div.indexBox(v-wechat-title="$route.meta.title=(orgName + '：消费详情')")
     div.navBar
        van-nav-bar(:title="orgName + '：消费详情'" left-text='返回' left-arrow fixed @click-left='back')
     div.headBox
        div.statiBox
            div.title 会员信息
            div.content
                div.statiItem
                   div.name 卡余额
                   div.value {{customerInfo&&customerInfo.maCustomerCard?customerInfo.maCustomerCard.balanceAmount:'0'}}元
                div.statiItem
                   div.name 卡赠金
                   div.value {{customerInfo&&customerInfo.maCustomerCard?customerInfo.maCustomerCard.handselAmount:'0'}}元
                div.statiItem
                   div.name 卡积分
                   div.value {{customerInfo&&customerInfo.maCustomerCard?customerInfo.maCustomerCard.accountPoints:'0'}}
                div.statiItem
                   div.name 余次卡
                   div.value {{balanceCounts}}次
     div.payListInfo
         van-button.btn.btn1(size='large' text='查看储值消费记录' @click="toPayInfo('cardPay')") 
         van-button.btn.btn2(size='large' text='查看扣次消费记录' @click="toPayInfo('tcardpay')")
         van-button.btn.btn3(size='large' text='查看购买次数记录' @click="toPayInfo('addTcard')")
     div.payOutBox   
        div.title 最近消费
        div.payOutItem(v-for='item in businessList')
            div.payOutLeft
               div.text {{item.businessName}}{{item.realAmount}}元（{{item.proName}}）
               div.time {{item.createTime}}
            div.payOutRight(@click='toPayItem(item)')
               div.moreBtn 详情
     div.wxNoticBox
        van-button.wxNoticBtn(size='large' text='开通微信消费通知' @click='wxNotic')
     div.descBox
        div.descItem 版权归美安软件所有，技术支持QQ：504503200
        div.descItem 售后热线：18980811900（同微信）
</template>

<script>
  import { NavBar, Button, Toast, Icon, Dialog } from 'vant';
  import svgIcon from './common/icon';
  import { mapGetters,mapMutations } from 'vuex';

  export default {
    components: {
      'svgIcon':svgIcon,
      [Button.name]: Button,
      [Toast.name]: Toast,
      [Icon.name]: Icon,
      [NavBar.name]: NavBar,
      [Dialog.name]: Dialog
    },
    name: 'login',
    created() {
        this.showInfo();
        this.showBusinessList();
        this.orgName = this.viewParams.shopInfo.ORGNAME;
        this.orgId = this.viewParams.shopInfo.ORGID;
    },
    computed: {
      ...mapGetters([
        'viewParams',
        'openId'
      ])
    },
    data() {
      return {
        orgName:'',
        orgId:'',
        customerInfo:{},
        balanceCounts:0,
        businessList:[],
      };
    },
    methods:{
      back() {
        this.setTransition('move-right');
        this.$router.go(-1);
      },
      showInfo(){
        this.$http.post('/customer/getInfo', {'customerId':this.viewParams.customerInfo.fkCustomerId}).then((response) => {
            if (response.data.success) {
                this.customerInfo = response.data.content;
                if(this.customerInfo.maCustomerTcard && this.customerInfo.maCustomerTcard.length >0){
                    let balanceCounts = 0;
                    this.customerInfo.maCustomerTcard.forEach((item)=>{
                      balanceCounts = balanceCounts + item.balanceCounts;
                    });
                    this.balanceCounts = balanceCounts;
                }   
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      showBusinessList(){
        Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner'
        });
        this.$http.post('/business/showBusinessList', {'customerId':this.viewParams.customerInfo.fkCustomerId}).then((response) => {
            Toast.clear();
            if (response.data.success) {
                this.businessList = response.data.content.records;
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      toPayItem(item){
        this.setTransition('move-left');
        this.saveViewParams({'shopInfo':this.viewParams.shopInfo,'customerInfo':this.viewParams.customerInfo,'payItem':item});
        this.$router.push('/payItem');
      },
      wxNotic(type){
        if(!this.openId){
            Toast("未获取到openId,请联系管理员");
            return;
        }
        this.$http.post('/business/wxNotic',{'openId':this.openId,'customerId':this.viewParams.customerInfo.fkCustomerId,'type':type}).then((response) => {
            if (response.data.success) {
              if(response.data.content == 'exists'){
                Toast("已绑定,无需再次绑定");
              }else if(response.data.content == 'success'){
                Toast("绑定成功");
              }else if(response.data.content == 'occupy'){
                Dialog.confirm({
                  title: '提示',
                  message: '当前手机号码已绑定其他微信号，是否进行解绑并重新绑定？'
                }).then(() => {
                  this.wxNotic('cover');
                }).catch(() => {});
              }
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      toPayInfo(type){
        this.setTransition('move-left');
        this.$router.push({path: '/payInfo', query: {'businessType':type}});
      },
      ...mapMutations([
        'saveViewParams',
        'setTransition'
      ])
    }
  };
</script>

<style lang="less" scoped>
  .indexBox{
    background-color: rgb(246, 247, 248);
    overflow:scroll;
    overflow-y:hidden;
    overflow-x:hidden;
    min-height: 100%;
    .headBox{
      margin-top: 50px;
      background-color: white;
      .statiBox{
        width: 100%;
        .title{
          padding-top: 10px;
          padding-left: 15px;
          font-size: 15px;
          font-weight: 700;
        }
        .content{
          display: flex;
          text-align: center;
          align-items: center;
          justify-content: space-between;
          background-color: white;
          padding: 10px 15px;
          .statiItem{
            width: 80px;
            height: 50px;
            display: flex;
            flex-direction: column;
            text-align: center;
            align-items: center;  
            justify-content: center;
            border-radius: 15rpx;
            background-color: white;
            box-shadow: 0 2px 5px rgba(0,0,0,.1);
            border-color: transparent;
            border-radius: 5px;
            font-size: 13px;
            .value{
              padding-top: 3px;
            }
          }
        }
      }
    }
    .payListInfo{
      background-color: white;
      padding: 10px 15px;
      .btn{
        margin-bottom: 5px;
        width: 100%;
        height: 42px;
        line-height: 42px;
        border-radius:6px;
        font-size: 14px;
        color: white;
      }
      .btn1{
        background-image: linear-gradient( 135deg, #ABDCFF 10%, #0396FF 100%);
      }
      .btn2{
        background-image: linear-gradient( 135deg, #CE9FFC 10%, #7367F0 100%);      
      }
      .btn3{
        background-image: linear-gradient( 135deg, #FFCF71 10%, #2376DD 100%);
      }
    }
    .payOutBox{
      margin-top: 10px;
      background-color: white;
      padding-left: 15px;
      padding-bottom: 1px;
      .title{
          padding-top: 10px;
          font-size: 15px;
          margin-bottom: 10px;
          font-weight: 700;
      }
      .payOutItem{
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .payOutLeft{
          text-align: left;
          height: 40px;
          display: flex;
          flex-direction: column;
          .text{
            width: calc(100vw - 80px);
            font-size: 14px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .time{
            color: #969ba3;
            font-size: 13px;
            font-weight: 400;
            margin-top: 2px;
          }
        }
        .payOutRight{
            width: 70px;
            display: flex;
            align-items: right;
            justify-content:flex-end;
            color: #969799;
            font-size: 14px;
            padding-right: 15px;
            text-align: right;
            .moreBtn{
              padding: 8px 10px;
              border-radius: 5px;
              background-color: #0396FF;
              color: whitesmoke;
            }
        }
      }
    }
    .wxNoticBox{
      margin-top: 10px;
      background-color: white;
      padding:5px 15px;
      .wxNoticBtn{
           width: 100%;
           height: 42px;
           line-height: 42px;
           border-radius:6px;
           font-size: 14px;
           background: linear-gradient(to right, #4bb0ff, rgb(88,129,247));
           color: white;
      }
    }
    .descBox{
      width: 100%;  
      padding: 30px 0;
      font-size: 13px;
      color: #5c5c5c;
      .descItem{
        width: 100%;
        text-align: center;
        padding-top: 5px;
      }
    }
  }
</style>